import React from 'react';
import PropTypes from 'prop-types';
import { PharmacistHeader } from '~/shared/components';
import { Wrapper, Footer } from './styles';

const PharmacistLayout = ({ children }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Wrapper>
      <PharmacistHeader />
      {children}
      <Footer>
        Copyright © {currentYear} Einstein Hospital Israelita. Todos os direitos
        reservados.
      </Footer>
    </Wrapper>
  );
};

PharmacistLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PharmacistLayout;
